(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["6reasons"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initR6(root){
    if(root.dataset.r6Init) return;
    root.dataset.r6Init = '1';
    var grid = root.querySelector('.r6-grid');
    var dots = root.querySelector('.r6-dots');
    if(!grid || !dots) return;
    var cards = grid.querySelectorAll('.r6-card');
    if(!cards.length) return;
    dots.innerHTML = '';
    cards.forEach(function(c, i){
      var b = document.createElement('button');
      if(i === 0) b.className = 'active';
      b.addEventListener('click', function(){ c.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
      dots.appendChild(b);
    });
    var t;
    grid.addEventListener('scroll', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        var gc = grid.getBoundingClientRect();
        var center = gc.left + gc.width / 2;
        var gi = 0, min = 1e9;
        cards.forEach(function(c, i){
          var r = c.getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - center);
          if(d < min){ min = d; gi = i; }
        });
        [].forEach.call(dots.children, function(b, i){ b.classList.toggle('active', i === gi); });
      }, 60);
    });
  }
  function all(){ document.querySelectorAll('.r6-mslider').forEach(initR6); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.r6-mslider');
    if(r) initR6(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutomebr"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initLov(root){
    if(root.dataset.lovInit) return;
    root.dataset.lovInit = '1';
    var track = root.querySelector('.lov-track');
    if(!track) return;
    var cards = track.children;
    if(!cards.length) return;
    var dotsWrap = root.querySelector('.lov-dots');
    var gap = parseInt(root.dataset.gap, 10) || 26;
    var idx = 0;

    function perView(){ return window.innerWidth <= 900 ? 1 : (parseInt(root.dataset.per, 10) || 3); }
    function maxIdx(){ return Math.max(0, cards.length - perView()); }

    if(dotsWrap){
      dotsWrap.innerHTML = '';
      for(var i = 0; i < cards.length; i++){
        var b = document.createElement('button');
        if(i === 0) b.className = 'active';
        (function(n){ b.addEventListener('click', function(){ idx = Math.min(maxIdx(), n); render(); }); })(i);
        dotsWrap.appendChild(b);
      }
    }

    function render(){
      var step = cards[0].getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-idx * step) + 'px)';
      track.style.transition = 'transform .4s ease';
      if(dotsWrap){ [].forEach.call(dotsWrap.children, function(b, i){ b.classList.toggle('active', i === idx); }); }
    }
    function go(dir){ idx = Math.min(maxIdx(), Math.max(0, idx + dir)); render(); }

    var prev = root.querySelector('.lov-prev'), next = root.querySelector('.lov-next');
    if(prev) prev.addEventListener('click', function(){ go(-1); });
    if(next) next.addEventListener('click', function(){ go(1); });

    var resizeT;
    window.addEventListener('resize', function(){
      clearTimeout(resizeT);
      resizeT = setTimeout(function(){ idx = Math.min(idx, maxIdx()); render(); }, 150);
    });

    if(root.dataset.autoplay === 'true' && cards.length > perView()){
      var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
      setInterval(function(){
        idx = idx >= maxIdx() ? 0 : idx + 1;
        render();
      }, speed);
    }
  }
  function initAll(){ document.querySelectorAll('.lov').forEach(initLov); }
  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.lov');
    if(r) initLov(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqqq"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setH(item){
    var a = item.querySelector('.pfa-a');
    if(!a) return;
    a.style.maxHeight = item.classList.contains('open') ? (a.scrollHeight + 'px') : null;
  }
  function init(root){
    if(root.dataset.pfaInit) return;
    root.dataset.pfaInit = '1';
    var multi = root.classList.contains('pfa-multi');
    var items = root.querySelectorAll('.pfa-item');
    items.forEach(function(item){
      setH(item);
      var q = item.querySelector('.pfa-q');
      if(!q) return;
      q.addEventListener('click', function(){
        var willOpen = !item.classList.contains('open');
        if(!multi){
          items.forEach(function(x){ x.classList.remove('open'); setH(x); });
        }
        item.classList.toggle('open', willOpen);
        setH(item);
      });
    });
    window.addEventListener('resize', function(){ items.forEach(setH); });
  }
  function all(){ document.querySelectorAll('.pfa').forEach(init); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function(e){ var r = e.target.querySelector('.pfa'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heroo"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initHero(root){
    if(root.dataset.pluxyInit) return;
    root.dataset.pluxyInit = '1';

    var rot = root.querySelector('.rotator');
    if(rot){
      var items = rot.querySelectorAll('.rotator-item');
      if(items.length > 1){
        var ri = 0;
        setInterval(function(){
          items[ri].classList.remove('active');
          ri = (ri + 1) % items.length;
          items[ri].classList.add('active');
        }, parseInt(root.dataset.rotateSpeed, 10) || 3500);
      }
    }

    var slides = root.querySelectorAll('.testi-slide');
    var dotsWrap = root.querySelector('.dots');
    if(slides.length){
      var ti = 0;
      slides.forEach(function(s,i){ s.style.display = i === 0 ? 'block' : 'none'; });
      if(dotsWrap){
        dotsWrap.innerHTML = '';
        slides.forEach(function(_,i){
          var b = document.createElement('button');
          if(i === 0) b.className = 'active';
          b.addEventListener('click', function(){ ti = i; renderT(); });
          dotsWrap.appendChild(b);
        });
      }
      function renderT(){
        slides.forEach(function(s,i){ s.style.display = i === ti ? 'block' : 'none'; });
        if(dotsWrap) dotsWrap.querySelectorAll('button').forEach(function(b,i){ b.className = i === ti ? 'active' : ''; });
      }
      var prev = root.querySelector('.testi-prev'), next = root.querySelector('.testi-next');
      if(prev) prev.addEventListener('click', function(){ ti = (ti - 1 + slides.length) % slides.length; renderT(); });
      if(next) next.addEventListener('click', function(){ ti = (ti + 1) % slides.length; renderT(); });
      if(slides.length > 1){
        setInterval(function(){ ti = (ti + 1) % slides.length; renderT(); }, parseInt(root.dataset.testiSpeed, 10) || 6000);
      }
    }
  }
  function initAll(){ document.querySelectorAll('.pluxy-hero').forEach(initHero); }
  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.pluxy-hero');
    if(r) initHero(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stands-out"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPso(root){
    if(root.dataset.psoInit) return;
    root.dataset.psoInit = '1';
    var grid = root.querySelector('.pso-grid');
    var dots = root.querySelector('.pso-dots');
    if(!grid || !dots) return;
    var cards = grid.querySelectorAll('.pso-card');
    if(!cards.length) return;
    dots.innerHTML = '';
    cards.forEach(function(c, i){
      var b = document.createElement('button');
      if(i === 0) b.className = 'active';
      b.addEventListener('click', function(){ c.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
      dots.appendChild(b);
    });
    var t;
    grid.addEventListener('scroll', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        var gc = grid.getBoundingClientRect();
        var center = gc.left + gc.width / 2;
        var gi = 0, min = 1e9;
        cards.forEach(function(c, i){
          var r = c.getBoundingClientRect();
          var d = Math.abs((r.left + r.width / 2) - center);
          if(d < min){ min = d; gi = i; }
        });
        [].forEach.call(dots.children, function(b, i){ b.classList.toggle('active', i === gi); });
      }, 60);
    });
  }
  function all(){ document.querySelectorAll('.pso-mslider').forEach(initPso); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.pso-mslider');
    if(r) initPso(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPvr(root){
    if(root.dataset.pvrInit) return;
    root.dataset.pvrInit = '1';
    var track = root.querySelector('.pvr-track');
    if(!track) return;
    var cards = track.children;
    if(!cards.length) return;
    var dots = root.querySelector('.pvr-dots');
    var gap = parseInt(root.dataset.gap, 10) || 26;
    var idx = 0;
    function perView(){ return window.innerWidth <= 900 ? 1 : (parseInt(root.dataset.per, 10) || 3); }
    function maxIdx(){ return Math.max(0, cards.length - perView()); }
    if(dots){
      dots.innerHTML = '';
      for(var i = 0; i < cards.length; i++){
        var b = document.createElement('button');
        if(i === 0) b.className = 'active';
        (function(n){ b.addEventListener('click', function(){ idx = Math.min(maxIdx(), n); render(); }); })(i);
        dots.appendChild(b);
      }
    }
    function render(){
      var step = cards[0].getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-idx * step) + 'px)';
      track.style.transition = 'transform .4s ease';
      if(dots){ [].forEach.call(dots.children, function(b, i){ b.classList.toggle('active', i === idx); }); }
    }
    function go(d){ idx = Math.min(maxIdx(), Math.max(0, idx + d)); render(); }
    var prev = root.querySelector('.pvr-prev'), next = root.querySelector('.pvr-next');
    if(prev) prev.addEventListener('click', function(){ go(-1); });
    if(next) next.addEventListener('click', function(){ go(1); });
    var rt;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ idx = Math.min(idx, maxIdx()); render(); }, 150); });
  }
  function all(){ document.querySelectorAll('.pvr').forEach(initPvr); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function(e){ var r = e.target.querySelector('.pvr'); if(r) initPvr(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purchaseee"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.pxInit) return;
    root.dataset.pxInit = '1';

    // Gallery
    var imgs = root.querySelectorAll('.gal-img');
    var nav = root.querySelector('[data-gal-nav]');
    var dots = root.querySelector('[data-gal-dots]');
    if(imgs.length > 1){
      var gi = 0;
      if(dots){
        dots.innerHTML = '';
        imgs.forEach(function(_, i){
          var b = document.createElement('button'); b.type='button';
          if(i===0) b.className='active';
          b.setAttribute('aria-label','Image '+(i+1));
          b.addEventListener('click', function(){ gi=i; render(); });
          dots.appendChild(b);
        });
      }
      function render(){
        imgs.forEach(function(im,i){ im.classList.toggle('active', i===gi); });
        if(dots) dots.querySelectorAll('button').forEach(function(b,i){ b.className = i===gi?'active':''; });
      }
      var gp = root.querySelector('[data-gal-prev]'), gn = root.querySelector('[data-gal-next]');
      if(gp) gp.addEventListener('click', function(){ gi=(gi-1+imgs.length)%imgs.length; render(); });
      if(gn) gn.addEventListener('click', function(){ gi=(gi+1)%imgs.length; render(); });
    } else if(nav){
      nav.style.display = 'none';
    }

    // Countdown
    var cd = root.querySelector('[data-countdown]');
    if(cd){
      var base = (parseInt(cd.dataset.h,10)||0)*3600 + (parseInt(cd.dataset.m,10)||0)*60 + (parseInt(cd.dataset.s,10)||0);
      var total = base;
      function pad(n){ return n<10?'0'+n:n; }
      function tick(){
        if(total<=0) total = base;
        total--;
        var h=Math.floor(total/3600), m=Math.floor((total%3600)/60), s=total%60;
        cd.textContent = pad(h)+' : '+pad(m)+' : '+pad(s);
      }
      tick(); setInterval(tick, 1000);
    }
  }
  function initAll(){ document.querySelectorAll('.pluxy-purchase').forEach(init); }
  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.pluxy-purchase'); if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purshcepproduct"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.bbInit) return;
    root.dataset.bbInit = '1';
    var imgs = root.querySelectorAll('.bb-gal-img');
    var nav = root.querySelector('[data-gal-nav]');
    var dots = root.querySelector('[data-gal-dots]');
    if(imgs.length > 1){
      var gi = 0;
      if(dots){
        dots.innerHTML = '';
        imgs.forEach(function(_, i){
          var b = document.createElement('button'); b.type='button';
          if(i===0) b.className='active';
          b.addEventListener('click', function(){ gi=i; render(); });
          dots.appendChild(b);
        });
      }
      function render(){
        imgs.forEach(function(im,i){ im.classList.toggle('active', i===gi); });
        if(dots) dots.querySelectorAll('button').forEach(function(b,i){ b.className = i===gi?'active':''; });
      }
      var gp = root.querySelector('[data-gal-prev]'), gn = root.querySelector('[data-gal-next]');
      if(gp) gp.addEventListener('click', function(){ gi=(gi-1+imgs.length)%imgs.length; render(); });
      if(gn) gn.addEventListener('click', function(){ gi=(gi+1)%imgs.length; render(); });
      var main = root.querySelector('.bb-gal-main');
      if(main){
        var sx = 0, sy = 0, st = 0;
        main.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now(); }, { passive: true });
        main.addEventListener('touchend', function(e){
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && Date.now() - st < 800){
            gi = dx < 0 ? (gi + 1) % imgs.length : (gi - 1 + imgs.length) % imgs.length;
            render();
          }
        }, { passive: true });
      }
    } else if(nav){ nav.style.display='none'; }

    var look = root.querySelector('.bb-look-num');
    if(look){
      var base = parseInt(look.dataset.lookingBase, 10) || 200;
      var cur = base;
      setInterval(function(){
        var delta = Math.floor(Math.random()*5) - 2;
        cur = Math.max(base - 8, Math.min(base + 8, cur + delta));
        look.textContent = cur;
      }, 2600);
    }
  }
  function initAll(){ document.querySelectorAll('.bb').forEach(init); }
  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){ var r = e.target.querySelector('.bb'); if(r) init(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviewww"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.jmInit) return;
    root.dataset.jmInit = '1';
    var grid = root.querySelector('.jm-grid');
    if(!grid) return;
    var allCards = Array.prototype.slice.call(grid.querySelectorAll('.jm-card'));
    var sel = root.querySelector('.jm-sort-sel');
    var btn = root.querySelector('.jm-load-btn');
    var step = parseInt(root.dataset.step, 10) || 6;
    var shown = step;
    function num(c, k){ return parseFloat(c.dataset[k]) || 0; }
    function flag(c, k){ return c.dataset[k] === '1'; }

    function buildList(){
      var sort = sel ? sel.value : 'recent';
      var list = allCards.slice();
      if(sort === 'highest') list.sort(function(a,b){ return num(b,'rating') - num(a,'rating'); });
      else if(sort === 'lowest') list.sort(function(a,b){ return num(a,'rating') - num(b,'rating'); });
      else if(sort === 'helpful') list.sort(function(a,b){ return num(b,'helpful') - num(a,'helpful'); });
      else if(sort === 'picsfirst') list.sort(function(a,b){ return (flag(b,'haspic')?1:0) - (flag(a,'haspic')?1:0); });
      else if(sort === 'vidsfirst') list.sort(function(a,b){ return (flag(b,'hasvid')?1:0) - (flag(a,'hasvid')?1:0); });
      if(sort === 'onlypics') list = list.filter(function(c){ return flag(c,'haspic') || flag(c,'hasvid'); });
      return list;
    }
    function apply(){
      var list = buildList();
      allCards.forEach(function(c){ if(list.indexOf(c) < 0) c.style.display = 'none'; });
      list.forEach(function(c, i){ grid.appendChild(c); c.style.display = i < shown ? '' : 'none'; });
      if(btn) btn.style.display = shown >= list.length ? 'none' : '';
    }
    if(sel) sel.addEventListener('change', function(){ shown = step; apply(); });
    if(btn){
      btn.addEventListener('click', function(e){
        if(btn.getAttribute('href') === '#' || !btn.getAttribute('href')){ e.preventDefault(); }
        shown += step; apply();
      });
    }
    apply();
  }
  function all(){ document.querySelectorAll('.jm').forEach(init); }
  if(document.readyState !== 'loading') all();
  else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', function(e){ var r = e.target.querySelector('.jm'); if(r) init(r); });

  // Write-a-review form handling
  document.querySelectorAll('.jm-form').forEach(function(form){
    var id = form.id.replace('jm-form-','');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      form.hidden = true;
      var success = document.getElementById('jm-success-' + id);
      if(success) success.hidden = false;
    });
  });

  // Close modal on backdrop click
  document.querySelectorAll('.jm-modal').forEach(function(dialog){
    dialog.addEventListener('click', function(e){
      if(e.target === dialog) dialog.close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ucg"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ugcInit) return;
    root.dataset.ugcInit = '1';
    var top = root.querySelector('[data-to-top]');
    if(top){
      top.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
  }
  function initAll(){ document.querySelectorAll('.pluxy-ugc').forEach(init); }
  if(document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.pluxy-ugc'); if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
